import { patternEmail } from '@/utils/helpers';

export const required = (msg) => (v) => !!v || msg;
export const min = (count) => (v) => v.length >= count || `Минимум ${count} символов`;

export const phone = (v) => v.replace(/\D/g, '').length === 11 || 'Введите номер телефона';
export const email = (v) => patternEmail.test(v) || 'Введите корректный e-mail';
export const digits = (v) => !/[^0-9]/.test(v) || 'Введите только цифры';
